import { GUEST_ID_PATTERN } from '@v2/multiplayer'

const ID_KEY = 'tabletop:guest-id'
const NAME_KEY = 'tabletop:name'
const COOKIE = 'tt_guest'

function read(key: string): string | null { try { return localStorage.getItem(key) } catch { return null } }
function write(key: string, value: string) { try { localStorage.setItem(key, value) } catch { /* Private browsing may disable storage. */ } }

function mintGuestId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(18))
  return `guest_${btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')}`
}

/**
 * Identity is a browser-minted guest id. It travels as a header on ordinary requests and,
 * because WebSocket upgrades cannot carry headers, also as a same-site cookie.
 */
export function guestId(): string {
  let id = read(ID_KEY)
  if (!id || !GUEST_ID_PATTERN.test(id)) { id = mintGuestId(); write(ID_KEY, id) }
  document.cookie = `${COOKIE}=${id}; Path=/; Max-Age=31536000; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`
  return id
}
export function identityHeaders(): Record<string, string> { return { 'x-tabletop-guest': guestId() } }
export function savedName(): string { return read(NAME_KEY) ?? '' }
export function saveName(name: string) { write(NAME_KEY, name.trim().slice(0, 40)) }
